import React from "react";
import { Link, useNavigate } from "react-router-dom";

import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";

export default function Forbidden403() {
  const navigate = useNavigate();

  const makeRedirect = () => {
    const userData = localStorage.getItem("loggedInUserInfo");
    if (userData !== null && userData !== undefined) {
      try {
        const parsedData = JSON.parse(userData);
        const userType = parsedData?.user_type;

        if (userType === "CCN_Internal") {
          navigate("/ccn");
        } else if (userType === "WAH") {
          navigate("/wah");
        } else if (userType === "MRB") {
          navigate("/mrb");
        } else {
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Error parsing userData:", error);
        navigate("/");
      }
    } else {
      navigate("/");
    }
  };

  return (
    <>
      <Header />
      <div className="bg-primary pt-5 pb-20">
        <div className="container">
          <div className="row"></div>
        </div>
      </div>
      <div className="bg-white py-3">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="card w-100 mt-n20 bg-white rounded-3 shadow-sm mb-5">
                <div className="card-body p-3">
                  <div>
                    <h1 className="display-1 fw-bold text-danger">403</h1>
                    <p className="fs-3">
                      🚫 <span className="text-dark">Forbidden:</span> You don't
                      have permission to access this page.
                    </p>
                    <p className="lead">
                      Please check your access rights or contact the
                      administrator.
                    </p>
                    <button onClick={makeRedirect} className="btn btn-primary mt-3">
                      Go Home
                    </button>
                    {/* 👆 Use <button> instead of <Link> if you're handling onClick navigation */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
